module.exports = __webpack_public_path__ + "static/media/fingerPoint.fe35b496.svg";